







































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import DataCard from "@/components/Common/DataCard.vue";

interface SelectOption {
  value: number;
  text: string;
}

@Component({
  components: {
    DataCard
  },
  filters: {
    capitalize(value: string) {
      if (!value) {
        return "";
      }
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
})
export default class ApplicationDetail extends Vue {
  private id: string = "";
  private tarjeta: null | any = "";
  private codTarjeta: null | any;
  private loading: boolean = false;
  private loadingImage: boolean = false;
  private cardImage = new Image();
  private typeOptions: SelectOption[] = [];
  private neighboType: SelectOption[] = [];
  private genderOptions: SelectOption[] = [];
  private nationOptions: SelectOption[] = [];
  private cStateOptions: SelectOption[] = [];

  private data = {
    id: "",
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    email: "",
    estadoCivil: 0,
    fechaNacimiento: "",
    estado: "",
    nacionalidad: 0,
    prevision: 0,
    rut: "",
    sexo: 0,
    telefono: 0,
    tipo: 0,
    codigo: "",
    direccion: {
      calle_id: 0,
      calle: "",
      numero: 0,
      block: "",
      depto: "",
      referencia: "",
      comuna: ""
    },
    qr: new Image(),
    boleta: "no",
    entidad: "",
    tipoVecino: 0
  };
  private birthDay: Date = new Date();
  private prevition: string = "";
  private canvas: any = null;

  get user() {
    return this.$store.state.user;
  }

  get fullName() {
    if (this.data) {
      return `${this.data.nombre} ${this.data.apellidoPaterno} ${this.data.apellidoMaterno}`;
    } else {
      return "";
    }
  }
  private formatRut(rut: string) {
    rut = rut.replace(/\./g, "").replace(/-/g, "");
    const rutNumber = rut
      .substring(0, rut.length - 1)
      .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
    const dv = rut.substring(rut.length - 1);
    return `${rutNumber}-${dv}`.toUpperCase();
  }

  private getOptionText(option: SelectOption[], id: number) {
    const result = option.find(element => element.value === id);
    return result ? result.text.toUpperCase() : this.$t("messages.no_info");
  }

  // private printImage() {
  //   let formattedRut = this.data.rut
  //     .split("-")[0]
  //     .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  //   formattedRut = formattedRut + "-" + this.data.rut.split("-")[1];
  //   formattedRut = formattedRut.toUpperCase();
  //   // const canvas = document.getElementById("myCanvas") as any;
  //   // const localCardImage = new Image();
  //   // localCardImage.src = require("@/assets/tarjeta.png");
  //   if (this.canvas && this.data.qr.complete) {
  //     this.canvas.width = 1201;
  //     this.canvas.height = 2001;
  //     const ctx = this.canvas.getContext("2d");

  //     ctx.drawImage(this.cardImage, 0, 0);

  //     ctx.font = "600 50px Verdana";
  //     ctx.fillStyle = "#444444";
  //     ctx.textAlign = "center";

  //      let apellido = this.data.apellidoPaterno.toUpperCase();
  //         if (this.data.apellidoMaterno && this.data.apellidoMaterno != "") {
  //           apellido =
  //             this.data.nombre.toUpperCase() +
  //             " " +
  //             apellido +
  //             " " +
  //             this.data.apellidoMaterno.toUpperCase();
  //         }
  //         ctx.fillText(apellido, this.canvas.width / 2 - 5, 350);

  //         ctx.fillText(formattedRut, this.canvas.width / 2 - 5, 425);

  //         if (this.data.codigo) {
  //           ctx.fillText(
  //             this.data.codigo,
  //             this.canvas.width / 2 - 2,
  //             160 + (this.data.qr.height * 0.75) / 2 + 270
  //           );
  //         } else {
  //           ctx.fillText(
  //             "1234567891",
  //             this.canvas.width / 2 - 2,
  //             160 + (this.data.qr.height * 0.75) / 2 + 270
  //           );
  //         }

  //         ctx.drawImage(
  //           this.data.qr,
  //           0,
  //           0,
  //           this.data.qr.width,
  //           this.data.qr.height,
  //           this.canvas.width / 4 + 60,
  //         590,
  //           this.data.qr.width * 1.45 - 50,
  //           this.data.qr.height * 1.45 - 50
  //         );

  //         ctx.font = "600 45px Verdana";
  //         let tipo_vecino_label = "RESIDENTE";
  //         if (this.data.tipoVecino == 3) {
  //           tipo_vecino_label = "ESTUDIANTE";
  //         } else if (this.data.tipoVecino == 4) {
  //           tipo_vecino_label = "TRABAJADOR";
  //         }
  //         ctx.fillText(tipo_vecino_label, this.canvas.width / 2 - 5, 1110);


  //     const element = document.createElement("a");
  //     element.style.display = "none";
  //     element.setAttribute("href", this.canvas.toDataURL("image/png"));
  //     element.setAttribute("download", "Tarjeta.png");
  //     document.body.appendChild(element);
  //     element.click();
  //     document.body.removeChild(element);
  //   }
  // }

  private printImage() {
  let formattedRut = this.data.rut
    .split("-")[0]
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  formattedRut = formattedRut + "-" + this.data.rut.split("-")[1];
  formattedRut = formattedRut.toUpperCase();

  if (this.canvas && this.data.qr.complete) {
    this.canvas.width = 1201;
    this.canvas.height = 2001;
    const ctx = this.canvas.getContext("2d");
    const centerX = this.canvas.width / 2.2; // Definimos el centro exacto

    ctx.drawImage(this.cardImage, 0, 0);

    ctx.font = "600 50px Verdana";
    ctx.fillStyle = "black";
    ctx.textAlign = "center"; // Esto es clave

    let nombreCompleto = this.data.nombre.toUpperCase() + " " + this.data.apellidoPaterno.toUpperCase();
    if (this.data.apellidoMaterno && this.data.apellidoMaterno != "") {
      nombreCompleto += " " + this.data.apellidoMaterno.toUpperCase();
    }
    
    // --- TEXTO: NOMBRE ---
    ctx.fillText(nombreCompleto, centerX, 350);

    // --- TEXTO: RUT ---
    ctx.fillText(formattedRut, centerX, 425);

    // --- TEXTO: CÓDIGO (V000...) ---
    const codigoTexto = this.data.codigo ? this.data.codigo : "1234567891";
    ctx.fillText(codigoTexto, centerX, 535); // Ajustado para que quede sobre el QR

    // --- QR CODE: CENTRADO LÓGICO ---
    const qrWidth = this.data.qr.width * 1.45 - 50;
    const qrHeight = this.data.qr.height * 1.45 - 50;
    
    ctx.drawImage(
      this.data.qr,
      0,
      0,
      this.data.qr.width,
      this.data.qr.height,
      centerX - (qrWidth / 2), // Centro menos la mitad del ancho del QR
      590,
      qrWidth,
      qrHeight
    );

    // --- TEXTO: TIPO VECINO ---
    ctx.font = "600 45px Verdana";
    let tipo_vecino_label = "RESIDENTE";
    if (this.data.tipoVecino == 3) {
      tipo_vecino_label = "ESTUDIANTE";
    } else if (this.data.tipoVecino == 4) {
      tipo_vecino_label = "TRABAJADOR";
    }
    ctx.fillText(tipo_vecino_label, centerX, 1110);

    // Descarga de imagen...
    const element = document.createElement("a");
    element.style.display = "none";
    element.setAttribute("href", this.canvas.toDataURL("image/png"));
    element.setAttribute("download", "Tarjeta.png");
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}

  private async generarTarjeta() {
    this.$q.loading.show();
    await new Promise((resolve, reject) => {
      let formattedRut = this.data.rut
        .split("-")[0]
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      formattedRut = formattedRut + "-" + this.data.rut.split("-")[1];
      formattedRut = formattedRut.toUpperCase();

      if (this.canvas && this.data.qr.complete) {
        this.canvas.width = 1074;
        this.canvas.height = 1919;
        const ctx = this.canvas.getContext("2d");
        this.cardImage.onload = () => {
          ctx.drawImage(this.cardImage, 0, 0);
          ctx.font = "600 50px Verdana";
          ctx.fillStyle = "black";
          ctx.textAlign = "center";

          let apellido = this.data.apellidoPaterno.toUpperCase();
          if (this.data.apellidoMaterno && this.data.apellidoMaterno != "") {
            apellido =
              this.data.nombre.toUpperCase() +
              " " +
              apellido +
              " " +
              this.data.apellidoMaterno.toUpperCase();
          }
          ctx.fillText(apellido, this.canvas.width / 2 - 5, 350);

          ctx.fillText(formattedRut, this.canvas.width / 2 - 5, 425);

          if (this.data.codigo) {
            ctx.fillText(
              this.data.codigo,
              this.canvas.width / 2 - 2,
              160 + (this.data.qr.height * 0.75) / 2 + 270
            );
          } else {
            ctx.fillText(
              "1234567891",
              this.canvas.width / 2 - 2,
              160 + (this.data.qr.height * 0.75) / 2 + 270
            );
          }

          ctx.drawImage(
            this.data.qr,
            0,
            0,
            this.data.qr.width,
            this.data.qr.height,
            this.canvas.width / 4 + 60,
          590,
            this.data.qr.width * 1.45 - 50,
            this.data.qr.height * 1.45 - 50
          );

          ctx.font = "600 45px Verdana";
          let tipo_vecino_label = "RESIDENTE";
          if (this.data.tipoVecino == 3) {
            tipo_vecino_label = "ESTUDIANTE";
          } else if (this.data.tipoVecino == 4) {
            tipo_vecino_label = "TRABAJADOR";
          }
          ctx.fillText(tipo_vecino_label, this.canvas.width / 2 - 5, 1110);

          this.tarjeta = this.canvas.toDataURL("image/png");
          this.$q.loading.hide();
          resolve(this.canvas.toDataURL("image/png"));
        };
      }
    });
  }

  private mounted() {
    if (
      this.$router.currentRoute.params.id &&
      this.$router.currentRoute.params.id != ""
    ) {
      this.id = this.$router.currentRoute.params.id;
      this.$q.loading.show({
        delay: 100 // ms
      });

      this.$axios
        .get("vecino/profile?id=" + this.id)
        .then(res => {
          Object.assign(this.data, res.data);

          const qr = new Image();
          if (this.data.qr) {
            qr.src = `data: ${this.data.qr}`;
            this.data.qr = qr;
            this.cardImage.src = require("@/assets/tarjeta3.png");
          }
          var ua = navigator.userAgent.toLowerCase();
          let birthDate = "now";
          if (ua.indexOf("safari") != -1) {
            if (ua.indexOf("chrome") > -1) {
              birthDate = (this.data.fechaNacimiento.substring(0, 4) +
                "-" +
                this.data.fechaNacimiento.substring(5, 7) +
                "-" +
                this.data.fechaNacimiento.substring(8, 10) +
                " 12:00:00") as any;
            } else {
              birthDate = (this.data.fechaNacimiento.substring(0, 4) +
                "-" +
                this.data.fechaNacimiento.substring(5, 7) +
                "-" +
                this.data.fechaNacimiento.substring(8, 10) +
                "T12:00:00") as any;
            }
          } else if (ua.indexOf("mozilla") != -1) {
            //Usa Mozilla
            birthDate = this.data.fechaNacimiento;
          }
          this.birthDay = new Date(birthDate);
          this.loading = true;
        })
        .catch(res => {
          if (this.$router.currentRoute.name == "ApplicationsList") {
            this.$router.go(0);
          } else {
            this.$router.push({ name: "ApplicationsList" }).catch(err => {});
          }
        })
        .finally(() => {
          this.$q.loading.hide();
          if (this.data.qr) {
            this.canvas = document.getElementById("myCanvas") as any;
            this.generarTarjeta();
          }
        });

      this.$q.loading.show({
        delay: 100 // ms
      });
      this.$axios
        .get("prevision")
        .then(res => {
          const result = res.data.find(
            (element: any) => element.id === this.data.prevision
          );
          this.prevition = result ? result.nombre : "SIN INFORMACIÓN";
        })
        .catch(() => {
          this.prevition = "SIN INFORMACIÓN";
        })
        .finally(() => {
          this.$q.loading.hide();
        });
      this.$axios("parentesco")
        .then(res => {
          res.data.forEach((entry: any) => {
            this.typeOptions.push({
              value: entry.id,
              text: this.$t(`meta.type[${entry.id - 1}]`).toString()
            });
          });
        })
        .finally(() => {
          this.$q.loading.hide();
        });

      this.genderOptions.push(
        { value: 1, text: this.$t("meta.sex.male").toString() },
        { value: 0, text: this.$t("meta.sex.female").toString() }
      );
      this.neighboType.push(
        { value: 1, text: this.$t("meta.neighbor_types.neighbor").toString() },
        { value: 2, text: this.$t("meta.neighbor_types.worker").toString() },
        {
          value: 3,
          text: this.$t("meta.neighbor_types.worker_cmds").toString()
        }
      );
      this.cStateOptions.push(
        { value: 0, text: this.$t("meta.status.single").toString() },
        { value: 1, text: this.$t("meta.status.married").toString() },
        { value: 2, text: this.$t("meta.status.union").toString() },
        { value: 3, text: this.$t("meta.status.divorced").toString() },
        { value: 4, text: this.$t("meta.status.null").toString() },
        { value: 5, text: this.$t("meta.status.widow").toString() }
      );
      this.$q.loading.show({
        delay: 100 // ms
      });
      this.$axios("pais")
        .then(res => {
          if (this.$store.state.user.lenguage === "es") {
            this.nationOptions.push({
              value: res.data[46].id,
              text: res.data[46].nombre_es
            });
          } else if (this.$store.state.user.lenguage === "en") {
            this.nationOptions.push({
              value: res.data[46].id,
              text: res.data[46].nombre_en
            });
          }
          res.data.forEach((country: any, index: number) => {
            if (res.data.length - 1 !== index && index !== 46) {
              if (this.$store.state.user.lenguage === "es") {
                this.nationOptions.push({
                  value: country.id,
                  text: country.nombre_es
                });
              } else if (this.$store.state.user.lenguage === "en") {
                this.nationOptions.push({
                  value: country.id,
                  text: country.nombre_en
                });
              }
            }
          });
        })
        .finally(() => {
          this.$q.loading.hide();
        });

      // if (this.$store.state.tarjeta && this.$store.state.tarjeta != "") {
      //   this.tarjeta = this.$store.state.tarjeta;
      // } else if (
      //   localStorage.getItem("tarjeta") &&
      //   localStorage.getItem("tarjeta") != ""
      // ) {
      //   this.tarjeta = localStorage.getItem("tarjeta");
      // }
    } else {
      if (this.$router.currentRoute.name == "ApplicationsList") {
        this.$router.go(0);
      } else {
        this.$router.push({ name: "ApplicationsList" }).catch(err => {});
      }
    }
  }

  get age() {
    const today = new Date();
    const date = this.birthDay;
    if (date) {
      const age = (today.getTime() - date.getTime()) / (1000 * 3600 * 24 * 365);
      return age;
    }
    return 0;
  }

  private cardMenor() {
    if (this.age < 18) {
      return "row justify-center col-12 col-md-12";
    } else {
      return "col-12 col-md-7";
    }
  }
}
